<div class="error-wrapper">
	<mat-icon class="error-wrapper__cancel">cancel</mat-icon>
	<span class="error-wrapper__message"
		>We have failed with sending the details you filled. Please try again in a couple of minutes or send an email to our
		support team support@zesty.co
	</span>
	<mat-icon class="error-wrapper__clear" (click)="dismiss()">clear</mat-icon>
</div>
